export default __webpack_public_path__ + "media/images/fluxod_40px_transp-7f4ed67fa243cc69ade58614dfbc1784.png";